import styles from './AigcPromoEntry.module.less'
import cls from 'classnames'
import { useTranslation } from 'react-i18next'

interface Props {
  mobile?: boolean
  onClick: () => void
}

function AigcPromoEntry(props: Props) {
  const { t } = useTranslation()

  return (
    <div className={cls(styles.aigcPromoEntry, props.mobile && styles.mobile)} data-testid='aigc-promo-entry'>
      <div className={styles.text}>
        <p className={styles.line}>AIGC</p>
        <p className={styles.line}>{t('modals.aigcPromotionModal.floatTitle')}</p>
      </div>
      <button type='button' className={styles.action} data-testid='aigc-promo-entry-btn' onClick={props.onClick}>
        <span className={styles.badge}>🚀</span>
        <span>{t('pageHeader.signUp')}</span>
      </button>
    </div>
  )
}

export default AigcPromoEntry
